import { useRef } from "react";
import equal from "fast-deep-equal/es6";
import { connect } from "formik";
import { useInterval } from "../generic/useInterval";

function AutoSave({
  savedFields,
  formik,
  postData,
  saveField,
  saveFieldStatus,
  setLastSaved,
}) {
  // keep track of previous form values
  const prevValues = useRef(formik.values);

  // use all formik fields if no specific fields are given
  const fields = savedFields || Object.keys(formik.values);

  // set callback for setInterval
  const interval = () => {
    // diff current values against prev values
    const changedFields = fields.filter(
      (field) => !equal(prevValues.current[field], formik.values[field])
    );

    // create changes post obj if differences exist
    const changes = {};
    changedFields.forEach((field) => {
      // only field to post obj if no errors exist for that field
      if (!Object.prototype.hasOwnProperty.call(formik.errors, field)) {
        changes[field] = formik.values[field];
      }
    });

    // update if differences exist
    if (Object.keys(changes).length > 0) {
      // make api call
      saveField({ ...changes, ...postData });
      if (saveFieldStatus === "success") {
        const date = new Date(Date.now());
        setLastSaved(`Last Saved ${date.toLocaleTimeString()}`);
      }
      // set prevValues to the new values after update
      prevValues.current = { ...prevValues.current, ...changes };
    }
  };

  useInterval(interval, 3000);
  return null;
}

export default connect(AutoSave);
